// extracted by mini-css-extract-plugin
module.exports = {"learningTop":"brandsDetail_learningTop__4IKn6","catagory":"brandsDetail_catagory__3RhON","slash":"brandsDetail_slash__nWcTu"};